export class addImageFields {
    specimenCode?: string;
    internal?: InternalFields;
    external?: ExternalFields;
    uploadImage: string = null;
    disableBtn: boolean = true;
    isEdit: boolean = false;
    specimenYear?: string = "";
    mailingYear?: string = "";
    thumbnailURL?: string = "";
    constructor(init?: addImageFields) {
        Object.assign(this, init);
    }
}

export class InternalFields {
    image_id: number;
    magnification: string = "";
    squence: number = null;
    comment: string;
    constructor(init?: InternalFields) {
        Object.assign(this, init);
    }
}

export class ExternalFields {
    imagetype: string = "";
    category: string = "";
    imagesubtype: string = "";
    imagename: string;
    thumbnail: boolean;
    group: string;
    constructor(init?: ExternalFields) {
        Object.assign(this, init);
    }
}

export class ImageFields {
    specimenCode: string = "";
    fullPath: string = "";
    name: string = "";
    id: number;
    magnification: string = "";
    comment: string = "";
    typeDesc: string = "";
    subTypeCode: string = "";
    subTypeDesc: string = "";
    sequence: number;
    externalName: string = "";
    approveFlag: string = "";
    group: string = "";
    thumbnailView: string = "";
    extComment: string = "";
    specLink: number;
    spec: string = "";
    imageNumber: number;
    lastUpdated: string = "";
    lastUpdatedUser: string = "";
    logInfo: string = "";
    diagnosis: string = "";
    diagnosisDesc: string = "";
    actionDiagnosis: string = "";
    diagnosisMenu: string = "";
    typeCode: string = "";
    mailing: number;
    mailingYear: string = "";
}